import { render, staticRenderFns } from "./CreativePreviewWrapper.vue?vue&type=template&id=48da8317"
import script from "./CreativePreviewWrapper.vue?vue&type=script&lang=js"
export * from "./CreativePreviewWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports